import { Box, Tooltip } from "@mui/material"
import uniqolor from "uniqolor"

/**
 * A skill's short code in a tinted box, matching how the schedule screens show a task's
 * skill (routes/schedule/tasks/skill-set.js); the full skill name is in the tooltip.
 */
export function ScheduleTaskSkillBadge({ skillName, skillCode }) {
    return (
        <Tooltip title={skillName}>
            <Box
                component="span"
                aria-label={`Skill: ${skillName}`}
                data-cy="schedule-task-skill"
                sx={{
                    px: 0.75,
                    borderRadius: 0.5,
                    fontSize: 11,
                    fontWeight: 500,
                    lineHeight: "18px",
                    flexShrink: 0,
                    bgcolor: `${uniqolor(skillName).color}40`,
                }}
            >
                {skillCode}
            </Box>
        </Tooltip>
    )
}
